"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ConfirmationPopup_1 = __importDefault(require("@Components/Popups/ConfirmationPopup"));
const Popup_1 = __importDefault(require("@Components/Popups/Popup"));
const react_1 = __importStar(require("react"));
const contexts_1 = require("@App/contexts");
require("./index.scss");
const BulkRelinquishmentConfirmationPopup = (props) => {
    const [hasConfirmed, setHasConfirmed] = (0, react_1.useState)(false);
    const { overclaimSearchStore, preloaderStore, userStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const { onClose, totalWorks } = props;
    const onCancel = () => __awaiter(void 0, void 0, void 0, function* () {
        preloaderStore.openTransparentPreloader(true);
        yield overclaimSearchStore.searchForWorks(overclaimSearchStore.pagination);
        overclaimSearchStore.resetOverclaimSelectionForBulkAction();
        setHasConfirmed(false);
        onClose();
        preloaderStore.openTransparentPreloader(false);
    });
    const submitBulkRelinquishment = () => __awaiter(void 0, void 0, void 0, function* () {
        preloaderStore.openTransparentPreloader(true);
        overclaimSearchStore
            .submitBulkRelinquishment()
            .then(() => {
            setHasConfirmed(true);
        })
            .finally(() => {
            preloaderStore.openTransparentPreloader(false);
        });
    });
    return (react_1.default.createElement(Popup_1.default, { className: 'bulk-overclaim-action-popup', onClose: hasConfirmed ? onCancel : onClose }, !hasConfirmed ? (react_1.default.createElement(ConfirmationPopup_1.default, { title: 'Relinquish work', onCancel: onClose, cancelButtonText: 'Cancel', confirmButtonText: 'Confirm', onConfirm: submitBulkRelinquishment, disabled: userStore.isInternal },
        react_1.default.createElement("h4", null,
            "Are you sure you want to relinquish all ",
            totalWorks,
            " works?"),
        "Confirming this will mean that the claimant is relinquishing all claims on these works.")) : (react_1.default.createElement(ConfirmationPopup_1.default, { title: 'Bulk Relinquish Complete!', onConfirm: onCancel, onCancel: () => {
            onCancel().then(() => {
                overclaimSearchStore.setIsOverclaimBulkActionStarted(true);
            });
        }, cancelButtonText: 'Start another relinquishment', confirmButtonText: 'Done' },
        react_1.default.createElement("h4", null,
            totalWorks,
            " works submitted to be processed")))));
};
exports.default = BulkRelinquishmentConfirmationPopup;
